module.exports = require("uncontrollable");


//////////////////
// WEBPACK FOOTER
// external "uncontrollable"
// module id = 19
// module chunks = 0